module.exports = __webpack_public_path__ + "img/daolan1.58ab7992.png";